export default function Hero() {
  const handleBook = () => {
    window.open('https://system.easypractice.net/book/equi#choose-where', '_blank');
  };

  const handleExplore = () => {
    const el = document.querySelector('#services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const services = [
    { icon: 'ri-eye-line', label: 'Bryn og Vipper' },
    { icon: 'ri-user-smile-line', label: 'Ansikt' },
    { icon: 'ri-sparkling-line', label: 'Plasma Pen / PRP' },
    { icon: 'ri-hand-heart-line', label: 'Fotpleie' },
    { icon: 'ri-leaf-line', label: 'Voksing' },
    { icon: 'ri-body-scan-line', label: 'Refit' },
    { icon: 'ri-heart-pulse-line', label: 'Massasje & Osteopati' },
    { icon: 'ri-plant-line', label: 'Kosthold' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0e0a07 0%, #1a1008 40%, #0e0a07 100%)',
      }}
    >
      {/* Background watermark */}
      <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
        <img
          src="https://storage.readdy-site.link/project_files/f7a91cb2-16ed-4f1e-969d-5ece724c23c9/b03cb20b-4fb4-4837-9a55-89db62a7f1e0_equiIconPlain.png?v=4f72fd85e284e63ce2e4f62caa853a60"
          alt=""
          className="absolute right-0 top-1/2 -translate-y-1/2 w-[70%] sm:w-[55%] max-w-3xl opacity-5 object-contain"
        />
      </div>

      {/* Gold decorative lines */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" aria-hidden="true" />

      {/* Radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(201,168,76,0.08)_0%,_transparent_70%)]" aria-hidden="true" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-10 w-full pt-24 md:pt-28 pb-16 md:pb-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          {/* Left content */}
          <div className="flex-1 text-center lg:text-left w-full">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6">
              Løft frem din
              <br />
              <span className="text-[#c9a84c]">naturlige skjønnhet</span>
            </h1>

            <p className="text-white/60 text-base md:text-lg lg:text-xl leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8 md:mb-10">
              En unik og koselig klinikk i Rudshøgda med et bredt utvalg av moderne behandlinger — tilpasset deg og dine behov.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center lg:justify-start">
              <button
                onClick={handleBook}
                className="px-8 py-4 bg-[#c9a84c] text-[#0e0a07] font-semibold rounded-full hover:bg-[#e0c06a] active:scale-95 transition-all duration-300 text-sm tracking-wide whitespace-nowrap cursor-pointer"
              >
                Bestill time
              </button>
              <button
                onClick={handleExplore}
                className="px-8 py-4 border border-white/20 text-white rounded-full hover:border-[#c9a84c]/60 hover:text-[#c9a84c] active:scale-95 transition-all duration-300 text-sm tracking-wide whitespace-nowrap cursor-pointer"
              >
                Utforsk tjenester
              </button>
            </div>
          </div>

          {/* Right — service pills */}
          <div className="flex-shrink-0 w-full lg:w-auto">
            <div className="grid grid-cols-2 gap-2.5 sm:gap-3 max-w-xs sm:max-w-sm mx-auto">
              {services.map((item) => (
                <button
                  key={item.label}
                  onClick={handleExplore}
                  className="flex items-center gap-2.5 sm:gap-3 px-3 sm:px-4 py-3 rounded-xl bg-white/5 border border-white/10 hover:border-[#c9a84c]/40 hover:bg-[#c9a84c]/5 active:scale-95 transition-all duration-300 cursor-pointer group text-left w-full"
                >
                  <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-[#c9a84c]/15 group-hover:bg-[#c9a84c]/25 transition-colors flex-shrink-0">
                    <i className={`${item.icon} text-[#c9a84c] text-xs sm:text-sm`} />
                  </div>
                  <span className="text-white/70 text-xs leading-tight group-hover:text-white/90 transition-colors">{item.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce" aria-hidden="true">
        <span className="text-white/30 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-[#c9a84c]/60 text-lg" />
      </div>
    </section>
  );
}